export const formatBytes = (bytes: number): string => {
  if (!bytes || bytes === 0) return null;

  const units = ["B", "KB", "MB"];

  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
};
